import { AbstractControl, ValidationErrors } from "@angular/forms";
import { IValidator } from "./IValidator";
import { AbstractValidator } from "./AbstractValidator";

import { Yii } from "libraries/interfaces/Yii";

export class MinChars extends AbstractValidator implements IValidator {

    public constructor(
        private readonly testValue: AbstractControl,
        private readonly min: number,
        private readonly isDisplayed?: (() => boolean) | boolean,
    ) {
        super({
            minChars: {
                when: 'touched',
                message: Yii.t('wui-shared-js', 'Le nombre de caractères min : ') + min,
            },
        });
    }

    public validate(): ValidationErrors | null {
        const isDisplayed: boolean = typeof this.isDisplayed === "function"
            ? this.isDisplayed()
            : this.isDisplayed;
        console.log(isDisplayed);
        if(isDisplayed === false){
            return null;
        }
        return this.testValue.value.length < this.min ? { minChars: true } : null;
    }
}
